import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const boardsDirectoryRedirectRoute: InvariantJiraRoute = {
	name: 'boards-directory-redirect',
	path: '/secure/ManageRapidViews.jspa',
};
